import React, { useEffect, useState } from "react";
import { getSupportGrantExpiryMs, goToSupportExpired, isInSupportMode } from "../../utils/supportGrant";
import "./SupportSessionTimer.css";

const formatRemaining = (ms) => {
  const totalSec = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  const pad = (n) => String(n).padStart(2, "0");
  return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
};

// Bottom-right countdown shown only while a support grant is active.
// Drives off the grant's JWT `exp` and redirects to /support-expired at zero.
const SupportSessionTimer = () => {
  const [remaining, setRemaining] = useState(null);

  useEffect(() => {
    if (!isInSupportMode()) return undefined;
    const expMs = getSupportGrantExpiryMs();
    if (!Number.isFinite(expMs)) return undefined;

    let intervalId;
    const tick = () => {
      const left = expMs - Date.now();
      setRemaining(left);
      if (left <= 0) {
        if (intervalId) clearInterval(intervalId);
        goToSupportExpired();
      }
    };
    tick();
    intervalId = setInterval(tick, 1000);
    return () => clearInterval(intervalId);
  }, []);

  if (remaining == null) return null;

  const isLow = remaining <= 60 * 1000;
  return (
    <div className={`support-session-timer${isLow ? " support-session-timer--low" : ""}`} role="status" aria-live="off">
      <span className="support-session-timer__dot" />
      <span className="support-session-timer__label">Support</span>
      <span className="support-session-timer__time">{formatRemaining(remaining)}</span>
    </div>
  );
};

export default SupportSessionTimer;
